/* Todo:
 * - Most images are inline hardcoded. Move them into const defined at the top
 * - Figure out a way to query image url from WP. The json API allows that but the graphql is too weak
 */

import React from 'react'
import { Link } from 'gatsby'
import { graphql } from 'gatsby'
import _ from 'lodash'

import Layout from '../components/layout'
import Grid from '../components/common/grid'
import AlternateGrid from '../components/common/alternate-grid'
import StoreImagelinks from '../components/storeimages'
import { safe_load_wp, html_decode } from '../utils'

/* Resource location */
const feat_img = [
  '/uploads/2018/10/for-web_feed_05.gif',
  '/uploads/home-section3.gif',
  '/uploads/2018/10/for-web_cashflow_03-1.gif',
]
const how_img = [
  '/uploads/2018/02/how_it_works_1.gif',
  '/uploads/2018/02/how_it_works_2.gif',
]
const security_img = [
  '/uploads/2018/02/security-case-1.png',
  '/uploads/2018/02/security-case-2.png',
  '/uploads/2018/02/security-case-3.png',
]

const LandingPage = props => {
  const wp = props.data.wordpressPage.acf

  wp.features_detail = _.map(wp.features_detail, (val, idx) => {
    val.image = feat_img[idx]
    return val
  })
  wp.how_detail = _.map(wp.how_detail, (val, idx) => {
    val.how_sub_image = how_img[idx]
    return val
  })
  wp.security_detail = _.map(wp.security_detail, (val, idx) => {
    val.security_sub_image = security_img[idx]
    return val
  })

  return (
    <Layout>
      {/* Landing*/}
      <section className="landing-main-wrapper">
        <div className="main-banner">
          <div className="main-banner__info main-banner__info--mobile">
            <h1 id="landing-title-mob">{wp.banner_heading}</h1>
          </div>
          <div className="main-banner__content">
            <div className="main-banner__info">
              <h1 id="landing-title">{wp.banner_heading}</h1>
              {safe_load_wp(wp.banner_description)}
            </div>
            <StoreImagelinks
              ios_link="https://1377.app.link/3Wl6QinwwS"
              goog_link="https://1377.app.link/JLbVAoCRWT"
            />
          </div>
          <div className="main-banner__img">
            <video className="" autoPlay="autoplay" loop="loop" muted="">
              <source src="/video/Homeanimation.mp4" type="video/mp4" />
              <source src="/video/animation.webm" type="video/webm" />
            </video>
          </div>
        </div>
      </section>

      {/* Press */}
      <section className="press-section">
        <div className="landing-main-wrapper">
          <div className="press-section__title">
            <span
              id="landing-press"
              dangerouslySetInnerHTML={{ __html: wp.logo_heading }}
            />
          </div>
          <div
            className="press-section__companies-logo"
            style={{ paddingBottom: '10px' }}
          >
            <a href="/">
              <img
                src="/uploads/2018/12/company-logo-4-e1545203474536.png"
                alt=""
              />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://imoney.hket.com/article/2025600/%E9%A6%99%E6%B8%AF%E7%B5%82%E6%96%BC%E8%BF%8E%E4%BE%86%E9%A6%96%E5%80%8B%E6%99%BA%E8%83%BD%E7%90%86%E8%B2%A1App"
            >
              <img src="/uploads/2018/12/iMoney-copy-3.png" alt="" />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.youtube.com/watch?v=USggXZPp08w&feature=youtu.be"
            >
              <img
                src="/uploads/2018/12/nowtv-copy-2-e1545202457483.png"
                alt=""
              />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.hk01.com/%E8%B2%A1%E7%B6%93%E5%BF%AB%E8%A8%8A/165967/%E9%87%91%E8%9E%8D%E7%A7%91%E6%8A%80%E5%88%9D%E5%89%B5gini%E6%8E%A8%E5%80%8B%E4%BA%BA%E7%90%86%E8%B2%A1app-%E4%B8%80%E6%AC%A1%E9%81%8E%E6%9F%A5%E7%9C%8B%E5%A4%9A%E9%96%93%E9%8A%80%E8%A1%8C%E5%B8%B3%E6%88%B6"
            >
              <img
                src="/uploads/2018/12/hk01-copy2-2-e1545204069180.png"
                alt=""
              />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://hk.finance.appledaily.com/finance/daily/article/20180313/20330384"
            >
              <img
                src="/uploads/2018/12/Apple-Daily-copy-2-2-e1545204213447.png"
                alt=""
              />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.youtube.com/watch?v=gP0b5RvGHN0"
            >
              <img
                src="/uploads/2018/12/Tvb-copy-2-1-e1545204427834.png"
                alt=""
              />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://hd.stheadline.com/news/columns/81/20181026/712453/"
            >
              <img
                src="/uploads/2018/12/Headline-Daily-copy-2-1-e1545204556799.png"
                alt=""
              />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.scmp.com/lifestyle/article/2136831/money-management-app-credit-card-happy-hongkongers-launched-city-start"
            >
              <img
                src="/uploads/2018/12/SCMP_color-copy-e1545204871447.png"
                alt=""
              />
            </a>
          </div>
        </div>
      </section>

      {/* Features */}
      <AlternateGrid
        items={wp.features_detail}
        first={props => (
          <div className="about-app">
            <div className="about-app__inner">
              <div className="about-app__info">
                <strong>{props.features_heading}</strong>
                {safe_load_wp(props.features_detail)}
                <Link to="/how-it-works">{html_decode(props.button_name)}</Link>
              </div>
              <div className="about-app__img-wrapper">
                <img src={props.image} alt="" />
              </div>
            </div>
          </div>
        )}
        second={props => (
          <div className="about-app about-app--reverse">
            <div className="about-app__inner">
              <div className="about-app__img-wrapper">
                <img src={props.image} alt="" />
              </div>
              <div className="about-app__info">
                <strong>{props.features_heading}</strong>
                {safe_load_wp(props.features_detail)}
                <Link to="/how-it-works">{html_decode(props.button_name)}</Link>
              </div>
            </div>
          </div>
        )}
      />

      {/* How it works */}
      <div id="how_it_works" className="how-it-works">
        <div className="how-it-works__inner">
          <div className="how-it-works__title">
            <strong id="how-section-title">{wp.how_heading}</strong>
          </div>
          <div className="how-it-works__steps">
            <Grid
              items={wp.how_detail}
              template={props => (
                <div className="how-it-works__step-item">
                  <div className="how-it-works__step-item-info">
                    <strong>{props.how_sub_heading}</strong>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: props.how_sub_detail,
                      }}
                    />
                    {props.how_button_text !== '' ? (
                      // todo
                      <a href={props.how_button_url}>{props.how_button_text}</a>
                    ) : null}
                  </div>
                  <div className="how-it-works__step-item-animation">
                    <img src={props.how_sub_image} alt="" />
                  </div>
                </div>
              )}
            />
          </div>
        </div>
      </div>

      {/* Security */}
      <div id="security_section" className="security-section">
        <div className="security-section__title">
          <strong id="security-title">{wp.security_heading}</strong>
        </div>
        <div className="security-section__cases">
          <Grid
            items={wp.security_detail}
            template={props => (
              <div className="security-section__case-item">
                <img src={props.security_sub_image} alt="" />
                <strong id="security-1-title">
                  {props.security_sub_heading}
                </strong>
                {safe_load_wp(props.security_sub_detail)}
              </div>
            )}
          />
        </div>
      </div>

      {/* Connect */}
      <div className="connect-section">
        <div className="connect-section__img-wrapper">
          <img src="/uploads/2018/02/connect-graphic.svg" alt="" />
        </div>
        <div className="connect-section__info">
          <strong id="getStarted-title">
            {html_decode(wp.connect_heading)}
          </strong>
          <p id="getStarted-detail">{wp.connect_detail}</p>
        </div>
      </div>

      {/* Partners */}
      <section className="landing-main-wrapper">
        <div className="partners-section">
          <div className="partners-section__title">
            <strong
              id="partners-pitch"
              dangerouslySetInnerHTML={{ __html: wp.aeroplane_text }}
            />
          </div>
          <div className="partners-section__img-wrapper">
            <img src="/uploads/2018/03/landing_graphic_1200.png" alt="" />
          </div>
          <div
            className="partners-section__info"
            dangerouslySetInnerHTML={{ __html: wp.gini_detail }}
          />
        </div>
      </section>
    </Layout>
  )
}

export const query = graphql`
  query LandingPage(
    $title: wordpressPageTitleQueryString_2 = { eq: "Home Page" }
  ) {
    wordpressPage(title: $title) {
      acf {
        banner_heading
        banner_description
        banner_newsletter
        newsletter_heading
        newsletter_form

        logo_heading
        logos {
          logo_link
        }

        aeroplane_text
        gini_detail
        bank_heading
        banks {
          bank_name
        }
        after_bank

        features_detail {
          features_heading
          features_detail
          button_name
        }

        how_heading
        how_detail {
          how_sub_heading
          how_sub_detail
          how_button_text
          how_button_url
        }

        security_heading
        security_detail {
          security_sub_image
          security_sub_heading
          security_sub_detail
        }

        connect_heading
        connect_detail
      }
    }
  }
`
export default LandingPage
